import * as React from 'react'
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'
import { CONFIG } from '../../../config'
import './backdrop.scss'

interface IProps {
  className?: string
  children: JSX.Element | JSX.Element[]
  contentCentered?: boolean
  onClick: () => void
  show: boolean
}

export class Backdrop extends React.Component<IProps> {
  baseClass: string = 'backdrop'

  onClick = (e: Event): void => {
    if ((e.target as HTMLElement).dataset.backdrop) {
      this.props.onClick()
    }
  }

  render(): React.ReactNode {
    const {
      children,
      className,
      contentCentered,
      show
    } = this.props

    const divProps: object = {
      [`data-${this.baseClass}`]: true,
      className: classNames({
        backdrop: true,
        [className]: className,
        'flex items--center justify--center': contentCentered
      }),
      onClick: this.onClick
    }

    return (
      <CSSTransition
        classNames={`${this.baseClass}-animation`}
        in={show}
        timeout={CONFIG.animation.timeouts.backdrop}
        unmountOnExit
      >
        <div {...divProps}>
          {children}
        </div>
      </CSSTransition>
    )
  }
}
